(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9444],{

/***/ 9444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ MainHome; }
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/Footer/Footer.jsx + 2 modules
var Footer = __webpack_require__(835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 5 modules
var slicedToArray = __webpack_require__(6588);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5258);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(5602);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(950);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(131);
// EXTERNAL MODULE: ./hooks/useCollection.js
var useCollection = __webpack_require__(2126);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(1766);
// EXTERNAL MODULE: ./services/helper.js + 182 modules
var helper = __webpack_require__(7058);
;// CONCATENATED MODULE: ./hooks/useStoreProducts.js






var fetchProducts = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var queryKey, _ref$pageParam, pageParam, _queryKey, storeId, collection, url, response, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryKey = _ref.queryKey, _ref$pageParam = _ref.pageParam, pageParam = _ref$pageParam === void 0 ? 1 : _ref$pageParam;
            _queryKey = (0,slicedToArray/* default */.Z)(queryKey, 3), storeId = _queryKey[1], collection = _queryKey[2];
            url = "".concat(helper/* publicServerEndpoint */.v2, "/v3/product/store/").concat(storeId, "/collectionv2?page=").concat(pageParam, "&limit=", 20, "&source=web");

            if (collection && collection !== "all") {
              url += "&collectionId=".concat(collection);
            }

            _context.next = 6;
            return fetch(url);

          case 6:
            response = _context.sent;

            if (response.ok) {
              _context.next = 9;
              break;
            }

            throw new Error("Failed to fetch products");

          case 9:
            _context.next = 11;
            return response.json();

          case 11:
            data = _context.sent;
            return _context.abrupt("return", {
              products: data.data.docs,
              nextPage: pageParam + 1,
              previousPage: pageParam > 1 ? pageParam - 1 : null,
              hasNextPage: data.data.hasNextPage
            });

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchProducts(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useStoreProducts = function useStoreProducts(storeId, collection) {
  return (0,useInfiniteQuery/* useInfiniteQuery */.N)(["storeProducts", storeId, collection], fetchProducts, {
    getNextPageParam: function getNextPageParam(lastPage) {
      return lastPage.hasNextPage ? lastPage.nextPage : undefined;
    },
    cacheTime: 30 * 1000,
    staleTime: 30 * 1000,
    keepPreviousData: true,
    enabled: !!storeId
  });
};

/* harmony default export */ var hooks_useStoreProducts = (useStoreProducts);
// EXTERNAL MODULE: ./pages/500.js
var _500 = __webpack_require__(7486);
// EXTERNAL MODULE: ./services/frontend/CartStorage.js + 1 modules
var CartStorage = __webpack_require__(5579);
// EXTERNAL MODULE: ./components/Cart/Basket.jsx + 1 modules
var Basket = __webpack_require__(3388);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/EmptyStore.jsx





var EmptyStore = function EmptyStore(_ref) {
  var _store$store, _store$store2, _store$store2$contact;

  var store = _ref.store;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "w-full flex items-center justify-center",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-[calc(var(--max-width)-200px)] flex flex-col justify-center items-center mt-[10vh]",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        className: "mt-12",
        src: "/smiley.png",
        width: "96",
        height: "96",
        alt: "Smiley"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-5 text-center text-[28px] font-bold text-[#1c3142]",
        children: "Oh deer, it\u2019s empty!"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mt-2 text-center text-[16px] italic text-[#1c3142] leading-[1.5]",
        children: [store === null || store === void 0 ? void 0 : (_store$store = store.store) === null || _store$store === void 0 ? void 0 : _store$store.storeName, " haven't added any", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " products to their shop yet.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " If you'd like to see them here, we'd", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " love for you to drop them an invite."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "instagram://user?username=".concat(store === null || store === void 0 ? void 0 : (_store$store2 = store.store) === null || _store$store2 === void 0 ? void 0 : (_store$store2$contact = _store$store2.contactInfo) === null || _store$store2$contact === void 0 ? void 0 : _store$store2$contact.instagramHandle),
        className: "mt-6 px-14 py-2.5 border border-black bg-black text-white rounded-lg hover:cursor-pointer",
        children: "INVITE"
      })]
    })
  });
};

/* harmony default export */ var components_EmptyStore = (EmptyStore);
// EXTERNAL MODULE: ./components/Navbar/index.jsx
var Navbar = __webpack_require__(2846);
// EXTERNAL MODULE: ./components/SideNavDrawer.jsx + 1 modules
var SideNavDrawer = __webpack_require__(471);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(3855);
// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(7756);
;// CONCATENATED MODULE: ./components/Skeleton.jsx


var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function Skeleton(_ref) {
  var className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    className: (0,utils.cn)("animate-pulse rounded-md bg-[#e8eaf6]", className)
  }, props));
}


;// CONCATENATED MODULE: ./components/SkeletonCard.jsx






var SkeletonCard = function SkeletonCard(_ref) {
  var _ref$imageClass = _ref.imageClass,
      imageClass = _ref$imageClass === void 0 ? "" : _ref$imageClass,
      _ref$titleClass = _ref.titleClass,
      titleClass = _ref$titleClass === void 0 ? "" : _ref$titleClass,
      _ref$descriptionClass = _ref.descriptionClass,
      descriptionClass = _ref$descriptionClass === void 0 ? "" : _ref$descriptionClass,
      _ref$containerClass = _ref.containerClass,
      containerClass = _ref$containerClass === void 0 ? "" : _ref$containerClass;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,utils.cn)("flex flex-col space-y-3", containerClass),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton, {
      className: (0,utils.cn)("h-[125px] w-[250px] rounded-xl", imageClass)
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "space-y-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton, {
        className: (0,utils.cn)("h-4 w-[250px]", titleClass)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton, {
        className: (0,utils.cn)("h-4 w-[200px]", descriptionClass)
      })]
    })]
  });
};

/* harmony default export */ var components_SkeletonCard = (SkeletonCard);
;// CONCATENATED MODULE: ./components/CollectionFilter.jsx



var CollectionFilter = function CollectionFilter(_ref) {
  var collection = _ref.collection,
      selectedCollection = _ref.selectedCollection,
      setFilter = _ref.setFilter;
  //console.log("CollectionFilter ", collection.name, selectedCollection.name);
  var isSelected = (collection === null || collection === void 0 ? void 0 : collection.name) === (selectedCollection === null || selectedCollection === void 0 ? void 0 : selectedCollection.name);

  var handleClick = function handleClick() {
    if (!isSelected) {
      console.log("set filter ", collection);
      setFilter(collection);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "m-[4px_5px_5px_4px] px-5 h-[40px] rounded-[20px] text-[13px] flex justify-center items-center tracking-[1px] whitespace-nowrap select-none capitalize ".concat(isSelected ? "bg-primary text-textOnPrimary" : "bg-secondary text-black"),
    onClick: handleClick,
    children: collection.name ? collection.name : "All Products"
  });
};

/* harmony default export */ var components_CollectionFilter = (CollectionFilter);
;// CONCATENATED MODULE: ./components/StoreCollections.jsx





var StoreCollections = function StoreCollections(_ref) {
  var collections = _ref.collections,
      setFilter = _ref.setFilter,
      selectedCollection = _ref.selectedCollection;
  var storeCollections = (0,react.useMemo)(function () {
    var list = [];
    list.push( /*#__PURE__*/(0,jsx_runtime.jsx)(components_CollectionFilter, {
      collection: ALL_PRODUCTS_OBJECT,
      selectedCollection: selectedCollection,
      setFilter: setFilter
    }, "initial"));
    var collectionList = react.Children.toArray(collections.map(function (collection) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_CollectionFilter, {
        collection: collection,
        selectedCollection: selectedCollection,
        setFilter: setFilter
      }, collection._id);
    }));
    return list.concat(collectionList);
  }, [collections, selectedCollection, setFilter]);
  return collections.length ? storeCollections : null;
};

/* harmony default export */ var components_StoreCollections = (StoreCollections);
// EXTERNAL MODULE: ./node_modules/lottie-react/build/index.umd.js
var index_umd = __webpack_require__(9260);
var index_umd_default = /*#__PURE__*/__webpack_require__.n(index_umd);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(2679);
// EXTERNAL MODULE: ./node_modules/react-lines-ellipsis/lib/index.js
var lib = __webpack_require__(7878);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./components/shimmer.json
var shimmer_namespaceObject = JSON.parse('{"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"Randy Varianda","k":"","d":"","tc":""},"fr":16,"ip":0,"op":32,"w":128,"h":128,"nm":"Lazy Load","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[-11.5,49,0],"to":[36.083,9.667,0],"ti":[-0.25,-0.083,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":40,"s":[204.99999999999997,107,0],"to":[0.25,0.083,0],"ti":[35.833,9.583,0]},{"t":59,"s":[-10,49.5,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[179.208,93.896,100],"ix":6}},"ao":0,"ef":[{"ty":29,"nm":"Gaussian Blur","np":5,"mn":"ADBE Gaussian Blur 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Blurriness","mn":"ADBE Gaussian Blur 2-0001","ix":1,"v":{"a":0,"k":34.3,"ix":1}},{"ty":7,"nm":"Blur Dimensions","mn":"ADBE Gaussian Blur 2-0002","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"Repeat Edge Pixels","mn":"ADBE Gaussian Blur 2-0003","ix":3,"v":{"a":0,"k":0,"ix":3}}]}],"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[7.721,144.227],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.7294117647058823,0.7490196078431373,0.8666666666666667,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-18.46,3.373],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,146.624],"ix":3},"r":{"a":0,"k":20.495,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":40,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[62.458000000000006,55.823,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120.328,77.977],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.9098039215686274,0.9176470588235294,0.9647058823529412,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1.542,8.177],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[109.644,176.784],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":40,"st":0,"bm":0}],"markers":[]}');
var components_shimmer_namespaceObject = /*#__PURE__*/__webpack_require__.t(shimmer_namespaceObject, 2);
;// CONCATENATED MODULE: ./components/StoreItem.jsx





 // Browser-compatible path parsing





var parseFileName = function parseFileName(url) {
  if (!url) return "";
  var parts = url.split("/");
  var filename = parts[parts.length - 1].split("?")[0];
  return {
    name: filename.substring(0, filename.lastIndexOf(".")),
    ext: filename.substring(filename.lastIndexOf("."))
  };
};

var StoreItem = function StoreItem(_ref) {
  var usedForCollectionhome = _ref.usedForCollectionhome,
      product = _ref.product,
      cohort = _ref.cohort;

  var _useState = (0,react.useState)(false),
      imageLoaded = _useState[0],
      setImageLoaded = _useState[1];

  var _useState2 = (0,react.useState)(false),
      fallbackSet = _useState2[0],
      setFallbackSet = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      imageName = _useState3[0],
      setImageName = _useState3[1];

  var router = (0,next_router.useRouter)();

  var getProductPrice = function getProductPrice(price) {
    var mrp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    if (!price) return;

    if (mrp) {
      var strikeOutMRP = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-sm font-light line-through opacity-60",
        children: "".concat(String.fromCharCode(0x20b9)).concat(mrp)
      });

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["".concat(String.fromCharCode(0x20b9)).concat(price), " ", strikeOutMRP]
      });
    } else {
      return "".concat(String.fromCharCode(0x20b9)).concat(product.price);
    }
  };

  var getImageUrl = function getImageUrl() {
    if (!imageName) return "";
    var imageurl = "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/".concat(imageName, ".jpg?width=500&height=500");
    return imageurl;
  };

  (0,react.useEffect)(function () {
    var urlPath = product.productPhotos && product.productPhotos[0] ? // eslint-disable-next-line no-undef
    new URL(product.productPhotos[0]).pathname : "";
    var extractedImageName = parseFileName(urlPath).name;
    setImageName(extractedImageName);
  }, [product.productPhotos]);

  var checkStock = function checkStock() {
    var stockAvailable = false;

    if (product.variantOptions && product.variantOptions.length) {
      product.variantOptions.forEach(function (variant) {
        if ((variant === null || variant === void 0 ? void 0 : variant.availableStock) > 0) {
          stockAvailable = true;
        }
      });
    } else {
      return product.availableStock;
    }

    return stockAvailable;
  }; // Calculate dynamic widths based on collection home usage


  var imageWidthClass = usedForCollectionhome ? "w-[calc((var(--max-width)/1.5)-50px)] h-[calc((var(--max-width)/1.5)-50px)]" : "w-[calc((100vw/2)-33px)] h-[calc((100vw/2)-33px)] md:w-[calc((520px/2)-33px)] md:h-[calc((520px/2)-33px)]";
  var itemWidthClass = usedForCollectionhome ? "max-w-[calc((var(--max-width)/1.5)-50px)] mb-3" : "max-w-[calc((100vw/2)-33px)] mb-8 md:max-w-[calc((520px/2)-33px)]";
  if (!product) return "";
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    href: "/product/".concat(product.id),
    className: "flex justify-start items-start flex-col ".concat(itemWidthClass),
    onClick: function onClick() {
      router.push("/product/".concat(product.id));
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: product && (product === null || product === void 0 ? void 0 : product.productPhotos[0]) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative rounded-lg",
          children: [!checkStock(product) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute h-[98%] flex justify-center rounded-lg items-center w-full font-bold font-lato text-2xl text-[#ff3333] z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "m-0 p-0 tracking-[3px]",
              children: "SOLD"
            })
          }), !imageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "rounded-lg ".concat(imageWidthClass),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((index_umd_default()), {
              className: "rounded-lg border",
              animationData: shimmer_namespaceObject || components_shimmer_namespaceObject,
              loop: true,
              autoplay: true,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(build.LazyLoadImage, {
            style: !imageLoaded ? {
              visibility: "hidden",
              height: "0px !important",
              width: "0px !important",
              zIndex: 1,
              position: "absolute"
            } : {},
            onLoad: function onLoad() {
              setImageLoaded(true);
            },
            onError: function onError(e) {
              if (!fallbackSet) {
                // Handle image load error by setting a fallback URL
                e.target.src = "".concat(product === null || product === void 0 ? void 0 : product.productPhotos[0]);
                setFallbackSet(true);
              }
            },
            className: "rounded-lg object-cover ".concat(imageWidthClass, " max-w-[none]"),
            src: getImageUrl(imageName, cohort),
            unoptimized: "true",
            objectfit: "cover",
            alt: product.name
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-col py-1",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-base mb-1 text-[#1c3142] opacity-80 font-normal font-roboto",
          children: product && /*#__PURE__*/(0,jsx_runtime.jsx)((lib_default()), {
            text: usedForCollectionhome ? product.name.length > 20 ? "".concat(product.name.substring(0, 20), "...") : product.name : product.name,
            maxLine: "2",
            ellipsis: "...",
            trimRight: true,
            basedOn: "letters"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-base font-bold text-[#1c3142] font-roboto",
          children: product && getProductPrice(product.price, product.mrp)
        })]
      })]
    })
  });
};

/* harmony default export */ var components_StoreItem = (StoreItem);
;// CONCATENATED MODULE: ./components/Home/RestorableList.jsx
 // eslint-disable-next-line no-undef



var _require = __webpack_require__(6006),
    WindowVirtualizer = _require.WindowVirtualizer; // --- SessionStorage Availability Check ---


function isSessionStorageAvailable() {
  try {
    if ( false || typeof window.sessionStorage === "undefined") {
      return false;
    }

    var testKey = "__restorable_list_test__";
    window.sessionStorage.setItem(testKey, testKey);
    window.sessionStorage.removeItem(testKey);
    return true;
  } catch (e) {
    console.warn("SessionStorage is not available or accessible: ".concat(e.message));
    return false;
  }
}

var RestorableList = function RestorableList(_ref) {
  var children = _ref.children;
  var cacheKey = "window-list-cache-1";
  var ref = (0,react.useRef)(null); // Check if sessionStorage is available

  var isSessionStorageAvailable = function isSessionStorageAvailable() {
    try {
      var testKey = "__storage_test__";
      window.sessionStorage.setItem(testKey, testKey);
      window.sessionStorage.removeItem(testKey);
      return true;
    } catch (e) {
      console.warn("sessionStorage not available:", e);
      return false;
    }
  }; // Safe sessionStorage getter


  var safeGetItem = function safeGetItem(key) {
    try {
      if (isSessionStorageAvailable()) {
        var _window, _window$sessionStorag;

        return (_window = window) === null || _window === void 0 ? void 0 : (_window$sessionStorag = _window.sessionStorage) === null || _window$sessionStorag === void 0 ? void 0 : _window$sessionStorag.getItem(key);
      }

      return null;
    } catch (e) {
      console.warn("Error accessing sessionStorage:", e);
      return null;
    }
  }; // Safe sessionStorage setter


  var safeSetItem = function safeSetItem(key, value) {
    try {
      if (isSessionStorageAvailable()) {
        var _window2, _window2$sessionStora;

        (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$sessionStora = _window2.sessionStorage) === null || _window2$sessionStora === void 0 ? void 0 : _window2$sessionStora.setItem(key, value);
      }
    } catch (e) {
      console.warn("Error setting sessionStorage:", e);
    }
  }; // Safe sessionStorage remover


  var safeRemoveItem = function safeRemoveItem(key) {
    try {
      if (isSessionStorageAvailable()) {
        var _window3, _window3$sessionStora;

        (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$sessionStora = _window3.sessionStorage) === null || _window3$sessionStora === void 0 ? void 0 : _window3$sessionStora.removeItem(key);
      }
    } catch (e) {
      console.warn("Error removing from sessionStorage:", e);
    }
  }; // Add error handling for ResizeObserver


  (0,react.useEffect)(function () {
    var handleError = function handleError(error) {
      if (error.message.includes("ResizeObserver")) {
        error.stopPropagation();
        return false;
      }
    };

    window.addEventListener("error", handleError);
    return function () {
      return window.removeEventListener("error", handleError);
    };
  }, []);

  var _useMemo = (0,react.useMemo)(function () {
    var serialized;
    serialized = safeGetItem(cacheKey);
    if (!serialized) return [];

    try {
      return JSON.parse(serialized); // eslint-disable-next-line no-unused-vars
    } catch (e) {
      return [];
    }
  }, []),
      offset = _useMemo[0],
      cache = _useMemo[1];

  (0,react.useLayoutEffect)(function () {
    if (!ref.current) return;
    var handle = ref.current;
    window.scrollTo(0, offset !== null && offset !== void 0 ? offset : 0);
    safeRemoveItem(cacheKey);
    var scrollY = 0;

    var onScroll = function onScroll() {
      scrollY = window.scrollY;
    };

    window.addEventListener("beforeunload", function () {
      safeRemoveItem(cacheKey);
    });
    window.addEventListener("scroll", onScroll);
    onScroll();
    return function () {
      window.removeEventListener("scroll", onScroll); // Use stored window.scrollY because it may return 0 in useEffect cleanup

      safeSetItem(cacheKey, JSON.stringify([scrollY, handle.cache]));
    };
  }, [offset]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WindowVirtualizer, {
    ref: ref,
    cache: cache,
    children: children
  });
};

/* harmony default export */ var Home_RestorableList = (RestorableList);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(1033);
;// CONCATENATED MODULE: ./components/Home/CollectionHome.jsx




function CollectionHome_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CollectionHome_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CollectionHome_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CollectionHome_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var ALL_PRODUCTS_OBJECT = {
  name: "all products",
  _id: "all"
};

var CollectionHome = function CollectionHome(_ref) {
  var _cart$products;

  var store = _ref.store,
      theme = _ref.theme;
  var router = (0,next_router.useRouter)();
  var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  var queryCollection = router.query.collection;

  var _useState = (0,react.useState)(ALL_PRODUCTS_OBJECT),
      selectedCollection = _useState[0],
      setSelectedCollection = _useState[1];

  var _useState2 = (0,react.useState)(null),
      lastEl = _useState2[0],
      setLastEl = _useState2[1];

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  var _useStoreProducts = hooks_useStoreProducts(store.id, selectedCollection === null || selectedCollection === void 0 ? void 0 : selectedCollection._id),
      productData = _useStoreProducts.data,
      isProductsLoading = _useStoreProducts.isLoading,
      isFetchingNextPage = _useStoreProducts.isFetchingNextPage,
      fetchNextPage = _useStoreProducts.fetchNextPage,
      hasNextPage = _useStoreProducts.hasNextPage,
      productError = _useStoreProducts.error;

  var _useCollection = (0,useCollection/* default */.Z)(store.id, ""),
      collectionsData = _useCollection.data,
      isCollectionsLoading = _useCollection.isLoading,
      collectionsError = _useCollection.error; // Assuming collectionsData is now structured as { collections: [...] }


  var collections = collectionsData ? collectionsData.collections : []; //console.log("shubham", collectionsData);
  // eslint-disable-next-line react-hooks/exhaustive-deps

  var products = (productData === null || productData === void 0 ? void 0 : productData.pages.flatMap(function (page) {
    return page.products;
  })) || [];

  var _useState3 = (0,react.useState)(CartStorage/* default.getInitialCart */.Z.getInitialCart()),
      cart = _useState3[0],
      setCart = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showCart = _useState4[0],
      setShowCart = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      showSideNav = _useState5[0],
      setShowSideNav = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isCartInitialized = _useState6[0],
      setIsCartInitialized = _useState6[1]; // Initialize cart from CartStorage when component mounts


  (0,react.useEffect)(function () {
    var initialize = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var initialCartData;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CartStorage/* default.initializeCart */.Z.initializeCart();

              case 2:
                initialCartData = _context.sent;
                setCart(initialCartData);
                setIsCartInitialized(true);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initialize() {
        return _ref2.apply(this, arguments);
      };
    }();

    initialize();
  }, []); // Update CartStorage when cart changes

  (0,react.useEffect)(function () {
    if (cart !== CartStorage/* default.getInitialCart */.Z.getInitialCart()) {
      CartStorage/* default.saveCart */.Z.saveCart(cart);
    }
  }, [cart]);
  var handleShowCart = (0,react.useCallback)(function () {
    var boolVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (isCollectionsLoading || collectionsError || productError) return;
    setShowCart(boolVal);
  }, [isCollectionsLoading, collectionsError, productError]);
  (0,react.useEffect)(function () {
    if (queryCollection) {
      var foundCollection = collections.find(function (c) {
        return c.name.trim().toLowerCase() === queryCollection.trim().toLowerCase();
      });
      setSelectedCollection(foundCollection);
    }
  }, [collections]);
  var setFilter = (0,react.useCallback)(function (collection) {
    queryClient.invalidateQueries(["storeProducts", store.id, collection]);
    queryClient.removeQueries(["storeProducts", store.id, selectedCollection]);
    setSelectedCollection(collection);
    router.push({
      pathname: router.pathname,
      query: CollectionHome_objectSpread(CollectionHome_objectSpread({}, router.query), {}, {
        collection: collection.name === "all products" ? "" : collection.name
      })
    }, undefined, {
      shallow: true
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [router]);
  (0,react.useEffect)(function () {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);
  (0,react.useEffect)(function () {
    if (!products.length) return;

    var _products$slice = products.slice(-1),
        _products$slice2 = (0,slicedToArray/* default */.Z)(_products$slice, 1),
        lastElement = _products$slice2[0];

    setLastEl(lastElement.id);
  }, [products]);

  var updateAndSaveCart = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(newCartData) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setCart(newCartData);
              _context2.next = 3;
              return CartStorage/* default.saveCart */.Z.saveCart(newCartData);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateAndSaveCart(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var updateAddedToCart = function updateAddedToCart(productId, value) {
    console.log("Product ".concat(productId, " added status: ").concat(value, " (update logic needed here if applicable)"));
  };

  if (collectionsError || productError) return /*#__PURE__*/(0,jsx_runtime.jsx)(_500["default"], {});
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-full min-h-[calc(100vh-268px)] mt-[38px] px-[22px] scrollbar-none",
    children: [isCartInitialized && (cart === null || cart === void 0 ? void 0 : (_cart$products = cart.products) === null || _cart$products === void 0 ? void 0 : _cart$products.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Basket/* default */.Z, {
      isBasketOpen: showCart,
      setCart: updateAndSaveCart,
      cartData: cart,
      updateAddedToCart: updateAddedToCart,
      handleShowCart: handleShowCart,
      store: store,
      setRefresh: function setRefresh() {}
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* default */.Z, {
      cartActive: cart.products.length > 0,
      handleShowCart: handleShowCart,
      hideInAdvance: false,
      homeActive: false,
      store: store,
      theme: theme,
      storeName: (store === null || store === void 0 ? void 0 : store.storeName) || "",
      toggleSideNav: function toggleSideNav() {
        return setShowSideNav(!showSideNav);
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SideNavDrawer/* default */.Z, {
      isOpen: showSideNav,
      toggleDrawer: function toggleDrawer() {
        return setShowSideNav(!showSideNav);
      },
      store: store
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: isCollectionsLoading || collections && collections.length > 0 ? "relative top-14 left-0 right-0 flex leading-8 mt-[5px] px-0 overflow-x-auto overflow-y-hidden max-w-[500px] h-12 scroll-smooth z-10 hide-scrollbar" : "",
      children: [collections && collections.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_StoreCollections, {
        collections: collections,
        setFilter: setFilter,
        selectedCollection: selectedCollection
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "h-5"
      }), isCollectionsLoading && Array(3).fill(0).map(function (_, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton, {
          className: "m-[4px_5px_5px_4px] px-5 py-[4px] rounded-[50px] w-[150px]"
        }, i);
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "grid mt-4 gap-[11px_22px] relative pt-16 min-h-[80vh]",
      children: [products.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Home_RestorableList, {
        children: react.Children.toArray(products.map(function (_, index) {
          var startIndex = index * 2;
          var endIndex = startIndex + 2;
          var rowProducts = products.slice(startIndex, endIndex);
          if (!rowProducts.length) return null;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "grid grid-cols-2 gap-4",
            children: react.Children.toArray(rowProducts.map(function (product) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                ref: lastEl === product.id ? ref : null,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_StoreItem, {
                  cohort: store.cohort.includes(2) ? store.cohort : null,
                  product: product,
                  top: index === 0
                })
              });
            }))
          });
        }))
      }) : !isProductsLoading && /*#__PURE__*/(0,jsx_runtime.jsx)(components_EmptyStore, {
        store: store
      }), (isFetchingNextPage || isProductsLoading) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-2 gap-4",
        children: Array(6).fill(0).map(function (_, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_SkeletonCard, {
              imageClass: "rounded-lg object-cover max-w-[none] w-[calc((100vw/2)-33px)] h-[calc((100vw/2)-33px)] md:w-[calc((520px/2)-33px)] md:h-[calc((520px/2)-33px)]",
              titleClass: "h-4 w-[calc((100vw/2)-33px)] md:w-[calc((520px/2)-33px)]",
              descriptionClass: "h-4 w-[calc((100vw/2)-150px)] md:w-[calc((520px/2)-150px)]",
              containerClass: "flex justify-start items-start flex-col max-w-[calc((100vw/2)-33px)] mb-8 md:max-w-[calc((520px/2)-33px)]"
            }, i)
          }, i);
        })
      })]
    })]
  });
};

/* harmony default export */ var Home_CollectionHome = (CollectionHome);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var react_player_lib = __webpack_require__(2004);
var react_player_lib_default = /*#__PURE__*/__webpack_require__.n(react_player_lib);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(615);
// EXTERNAL MODULE: ./components/Infobanner/static-infobanner.module.css
var static_infobanner_module = __webpack_require__(3405);
var static_infobanner_module_default = /*#__PURE__*/__webpack_require__.n(static_infobanner_module);
;// CONCATENATED MODULE: ./components/Infobanner/StaticInfoBanner.jsx




function StaticInfoBanner(_ref) {
  var text = _ref.text;
  if (text) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "relative",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (0,utils.cn)((static_infobanner_module_default()).infobanner, "!bg-primary !text-textOnPrimary"),
      children: text
    })
  });
  return null;
}
// EXTERNAL MODULE: ./node_modules/react-ellipsis-text/index.js
var react_ellipsis_text = __webpack_require__(48);
// EXTERNAL MODULE: ./node_modules/react-use-scroll-direction/dist/react-use-scroll-direction.esm.js
var react_use_scroll_direction_esm = __webpack_require__(1150);
// EXTERNAL MODULE: ./components/Buttons/index.js + 1 modules
var Buttons = __webpack_require__(366);
// EXTERNAL MODULE: ./components/utils/fileutil.js
var fileutil = __webpack_require__(2190);
// EXTERNAL MODULE: ./components/NavBar2/CartIconSvg.jsx
var CartIconSvg = __webpack_require__(4035);
;// CONCATENATED MODULE: ./components/NavBar2/NavBar2.jsx










var NavBar2 = function NavBar2(props) {
  var _props$store$storeBan, _props$store, _props$store$storeBan2, _props$store2;

  var _useState = (0,react.useState)(""),
      direction = _useState[0],
      setDirection = _useState[1];

  var _useScrollDirection = (0,react_use_scroll_direction_esm/* useScrollDirection */.C)(),
      isScrollingUp = _useScrollDirection.isScrollingUp,
      isScrollingDown = _useScrollDirection.isScrollingDown;

  var _useState2 = (0,react.useState)(false),
      isSideNavOpen = _useState2[0],
      setIsSideNavOpen = _useState2[1];

  (0,react.useEffect)(function () {
    isScrollingDown && setDirection("down");
    isScrollingUp && setDirection("up");
  }, [isScrollingDown, isScrollingUp]);

  var checkoutShouldHide = function checkoutShouldHide() {
    if ( true && window.scrollY > 120) {
      return true;
    }

    return false;
  };

  var hasBanner = (_props$store$storeBan = (_props$store = props.store) === null || _props$store === void 0 ? void 0 : (_props$store$storeBan2 = _props$store.storeBanner) === null || _props$store$storeBan2 === void 0 ? void 0 : _props$store$storeBan2.text) !== null && _props$store$storeBan !== void 0 ? _props$store$storeBan : false;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
    className: "w-full flex items-center justify-between z-50 transition-all duration-300 h-[4.5rem] ".concat(hasBanner ? "top-20" : "top-0", " ").concat(direction === "up" ? "opacity-100" : "", " ").concat(direction === "down" && checkoutShouldHide() ? "-top-16 opacity-0" : ""),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mx-auto w-full max-w-[var(--max-width)] flex items-center justify-between h-[5rem] px-6 py-2",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex w-full items-center justify-center z-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          className: "bg-transparent border-none absolute left-0",
          onClick: function onClick() {
            console.log("Toggling side navigation:", !isSideNavOpen);
            props.toggleSideNav();
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "block w-6 h-0.5 bg-primary mb-1"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "block w-6 h-0.5 bg-primary mb-1"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "block w-6 h-0.5 bg-primary"
          })]
        }), (_props$store2 = props.store) !== null && _props$store2 !== void 0 && _props$store2.logo ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          unoptimized: true,
          src: function () {
            var urlPath = props.store.logo ? new URL(props.store.logo).pathname : "";
            var extractedImageName = (0,fileutil/* parseFileName */.x)(urlPath).name;
            return "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/".concat(extractedImageName, ".jpg?quality=50");
          }(),
          alt: "".concat(props.store.storeName, " Logo"),
          width: props.theme.logoShape === "rectangle" ? 120 : 60,
          height: 60,
          className: "object-contain ".concat(props.theme.logoShape === "rectangle" ? "" : "rounded-full"),
          layout: "fixed",
          onClick: function onClick() {
            return window.location.href = window.location.origin;
          }
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "inline-block font-lato text-lg font-bold text-primary text-center cursor-pointer",
          onClick: function onClick() {
            return window.location.href = window.location.origin;
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_ellipsis_text["default"], {
            text: props.storeName,
            length: 25,
            tail: "..."
          })
        }), props.cartActive && !props.hideInAdvance && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "absolute right-0 z-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* ImageButton */.z, {
            action: function action() {
              return props.handleShowCart(true);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CartIconSvg/* default */.Z, {})
          })
        })]
      })
    })
  });
};

/* harmony default export */ var NavBar2_NavBar2 = (NavBar2);
// EXTERNAL MODULE: ./components/Home/featured-home.module.css
var featured_home_module = __webpack_require__(3046);
var featured_home_module_default = /*#__PURE__*/__webpack_require__.n(featured_home_module);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(6703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Home/FeaturedCollectionWithProd.jsx






function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var FeaturedCollectionWithProd = function FeaturedCollectionWithProd(_ref) {
  var cohort = _ref.cohort,
      collectionName = _ref.collectionName,
      productsData = _ref.productsData;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "m-5",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "text-2xl mt-[50px] mb-[30px] mx-[10px] text-center font-bold text-primary",
      children: capitalizeFirstLetter(collectionName ? collectionName : "")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex flex-row overflow-x-auto overflow-y-hidden gap-4 whitespace-nowrap hide-scrollbar",
      children: productsData.map(function (product) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(components_StoreItem, {
          cohort: cohort,
          usedForCollectionhome: true,
          product: product,
          pageSize: productsData.length
        }, product.id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/shop?collection=".concat(collectionName.replace(/ /g, "+")),
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "w-[90px] block text-center my-2 mx-auto bg-white text-primary py-2 px-4 text-sm border border-primary transition duration-300 ease-in-out hover:bg-primary hover:text-textOnPrimary",
        children: "View All"
      })
    })]
  });
};

/* harmony default export */ var Home_FeaturedCollectionWithProd = (FeaturedCollectionWithProd);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(6661);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQueries.mjs + 1 modules
var useQueries = __webpack_require__(645);
;// CONCATENATED MODULE: ./components/Home/utils.jsx





var useCollectionsQuery = function useCollectionsQuery(storeId) {
  return (0,useQuery/* useQuery */.a)({
    queryKey: ["collections", storeId],
    queryFn: function () {
      var _queryFn = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var url, response, collections;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "".concat(helper/* publicServerEndpoint */.v2, "/v3/collection/store/").concat(storeId, "?limit=5");
                _context.next = 3;
                return fetch(url);

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.json();

              case 6:
                collections = _context.sent;

                if (collections && collections.collections.length === 0) {
                  collections.push(ALL_PRODUCTS_OBJECT);
                }

                return _context.abrupt("return", collections.collections);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function queryFn() {
        return _queryFn.apply(this, arguments);
      }

      return queryFn;
    }(),
    enabled: !!storeId
  });
};
var useCollectionWithStoreProducts = function useCollectionWithStoreProducts(storeId) {
  var _useCollectionsQuery = useCollectionsQuery(storeId),
      collections = _useCollectionsQuery.data;

  var safeCollections = collections || [];
  var productQueries = (0,useQueries/* useQueries */.h)({
    queries: safeCollections === null || safeCollections === void 0 ? void 0 : safeCollections.map(function (collection) {
      return {
        queryKey: ["collectionProducts", storeId, collection._id],
        queryFn: function () {
          var _queryFn2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
            var _data$data;

            var idParam, url, response, data;
            return regenerator_default().wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    idParam = collection._id === "all" ? "" : collection._id;
                    url = "".concat(helper/* publicServerEndpoint */.v2, "/v3/product/store/").concat(storeId, "/collectionv2?page=1&limit=10&source=web&collectionId=").concat(idParam);
                    _context2.next = 4;
                    return fetch(url);

                  case 4:
                    response = _context2.sent;
                    _context2.next = 7;
                    return response.json();

                  case 7:
                    data = _context2.sent;
                    return _context2.abrupt("return", ((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.docs) || []);

                  case 9:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function queryFn() {
            return _queryFn2.apply(this, arguments);
          }

          return queryFn;
        }(),
        enabled: !!storeId
      };
    })
  });
  var combinedCollections = safeCollections.map(function (collection, index) {
    var _productQueries$index, _productQueries$index2;

    return {
      collection: collection,
      products: ((_productQueries$index = productQueries[index]) === null || _productQueries$index === void 0 ? void 0 : _productQueries$index.data) || [],
      isLoading: (_productQueries$index2 = productQueries[index]) === null || _productQueries$index2 === void 0 ? void 0 : _productQueries$index2.isLoading
    };
  });
  return {
    data: combinedCollections,
    loading: productQueries.some(function (query) {
      return query.isLoading;
    })
  };
};
;// CONCATENATED MODULE: ./components/Home/FeaturedHome.jsx























function FeaturedHome_capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var FeaturedHome = function FeaturedHome(_ref) {
  var _store$storeBanner, _cart$products;

  var theme = _ref.theme,
      store = _ref.store,
      updateHomeActive = _ref.updateHomeActive,
      heroMedia = _ref.heroMedia,
      heroMediaImages = _ref.heroMediaImages,
      heroMediaType = _ref.heroMediaType,
      heroTitle = _ref.heroTitle;

  var _useState = (0,react.useState)(CartStorage/* default.getInitialCart */.Z.getInitialCart()),
      cart = _useState[0],
      setCart = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isCartInitialized = _useState2[0],
      setIsCartInitialized = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showCart = _useState3[0],
      setShowCart = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showSideNav = _useState4[0],
      setShowSideNav = _useState4[1];

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    var initialize = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var initialCartData;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CartStorage/* default.initializeCart */.Z.initializeCart();

              case 2:
                initialCartData = _context.sent;
                setCart(initialCartData);
                setIsCartInitialized(true);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initialize() {
        return _ref2.apply(this, arguments);
      };
    }();

    initialize();
  }, []);

  var updateAndSaveCart = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(newCartData) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setCart(newCartData);
              _context2.next = 3;
              return CartStorage/* default.saveCart */.Z.saveCart(newCartData);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateAndSaveCart(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var updateAddedToCart = function updateAddedToCart(productId, value) {
    console.log("FeaturedHome: Product ".concat(productId, " added status: ").concat(value, " (update logic needed)"));
  };

  var handleShowCart = function handleShowCart() {
    var boolVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setShowCart(boolVal);
  };

  var _useCollectionWithSto = useCollectionWithStoreProducts(store.id),
      collectionsData = _useCollectionWithSto.data,
      isCollectionsLoading = _useCollectionWithSto.loading;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StaticInfoBanner, {
      text: store === null || store === void 0 ? void 0 : (_store$storeBanner = store.storeBanner) === null || _store$storeBanner === void 0 ? void 0 : _store$storeBanner.text
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "sticky top-0 w-full ".concat(heroMediaType === "image" ? "h-full" : "relative", " flex justify-center z-50"),
      children: [isCartInitialized && (cart === null || cart === void 0 ? void 0 : (_cart$products = cart.products) === null || _cart$products === void 0 ? void 0 : _cart$products.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Basket/* default */.Z, {
        isBasketOpen: showCart,
        setCart: updateAndSaveCart,
        cartData: cart,
        updateAddedToCart: updateAddedToCart,
        handleShowCart: handleShowCart,
        store: store,
        setRefresh: function setRefresh() {}
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavBar2_NavBar2, {
        cartActive: isCartInitialized && cart.products.length > 0,
        hideInAdvance: false,
        homeActive: true,
        storeName: heroTitle,
        handleShowCart: handleShowCart,
        store: store,
        theme: theme,
        toggleSideNav: function toggleSideNav() {
          return setShowSideNav(!showSideNav);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SideNavDrawer/* default */.Z, {
        isOpen: showSideNav,
        toggleDrawer: function toggleDrawer() {
          return setShowSideNav(!showSideNav);
        },
        store: store
      })]
    }), heroMediaType === "image" ? /*#__PURE__*/(0,jsx_runtime.jsx)(js/* Carousel */.lr, {
      autoPlay: true,
      infiniteLoop: true,
      showThumbs: false,
      showArrows: false,
      showStatus: false,
      className: (0,utils.cn)((featured_home_module_default()).carouselImageContainer),
      onClickItem: function onClickItem() {
        return router.push("/shop");
      },
      children: heroMediaImages.map(function (imageUrl) {
        var _store$cohort;

        var imageName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);
        var imgurlNew = (_store$cohort = store.cohort) !== null && _store$cohort !== void 0 && _store$cohort.includes(1) ? "https://ik.imagekit.io/dm2asset/dm2assetfull/".concat(imageName) : "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/".concat(imageName, "?width=500&quality=80");
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: imgurlNew,
            alt: imageName,
            className: "w-full h-full object-cover pb-8"
          })
        }, imageName);
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-full relative h-screen max-h-[90vh]",
      onClick: function onClick() {
        return router.push("/shop");
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((react_player_lib_default()), {
        url: heroMedia,
        playing: true,
        loop: true,
        muted: true,
        playsinline: true,
        width: "100%",
        height: "100%",
        className: (featured_home_module_default()).carouselVideoContainer
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-full flex flex-col items-center mt-2.5 z-10",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: function onClick() {
          return updateHomeActive(false);
        },
        className: "w-36 h-10 rounded-md bg-primary text-textOnPrimary flex justify-center items-center text-sm",
        children: "SHOP NOW"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "min-h-[400px] w-full",
      children: isCollectionsLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: Array(2).fill(0).map(function (_, index1) {
          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            (0,jsx_runtime.jsxs)("div", {
              className: "m-5",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton, {
                className: "w-28 h-8 mt-[50px] mb-[30px] mx-auto text-center font-bold text-primary"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex flex-row overflow-x-auto overflow-y-hidden gap-4 whitespace-nowrap hide-scrollbar",
                children: Array(2).fill(0).map(function (_2, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_SkeletonCard, {
                    className: "m-[4px_5px_5px_4px] px-5 py-[4px] rounded-[50px] w-[10px]" // eslint-disable-next-line react/no-array-index-key
                    ,
                    imageClass: "w-[calc((var(--max-width)/1.5)-50px)] h-[calc((var(--max-width)/1.5)-50px)]"
                  }, i);
                })
              })]
            }, index1)
          );
        })
      }) : collectionsData.length > 0 ? collectionsData.map(function (collection) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Home_FeaturedCollectionWithProd, {
          cohort: store.cohort,
          collectionName: FeaturedHome_capitalizeFirstLetter(collection.collection.name ? collection.collection.name : ""),
          productsData: collection.products
        }, collection.collection._id);
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "h-full flex items-center justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-gray-500"
        })
      })
    })]
  });
};

/* harmony default export */ var Home_FeaturedHome = (FeaturedHome);
;// CONCATENATED MODULE: ./components/Home/ScrollPositionProvider.jsx

 // Create the context


var ScrollContext = /*#__PURE__*/(0,react.createContext)(); // Create a provider component

var ScrollProvider = function ScrollProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(0),
      scrollPosition = _useState[0],
      setScrollPosition = _useState[1];

  var updateScrollPosition = (0,react.useCallback)(function (position) {
    setScrollPosition(position);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollContext.Provider, {
    value: {
      scrollPosition: scrollPosition,
      updateScrollPosition: updateScrollPosition
    },
    children: children
  });
}; // Custom hook to use the ScrollContext

var useScroll = function useScroll() {
  var _useState2 = useState(0),
      scrollPosition = _useState2[0],
      setScrollPosition = _useState2[1];

  useEffect(function () {
    var savedPosition = localStorage.getItem("scrollPosition");

    if (savedPosition) {
      setScrollPosition(parseInt(savedPosition, 10));
    }
  }, []);

  var updateScrollPosition = function updateScrollPosition(position) {
    localStorage.setItem("scrollPosition", position);
    setScrollPosition(position);
  };

  return {
    scrollPosition: scrollPosition,
    updateScrollPosition: updateScrollPosition
  };
};
;// CONCATENATED MODULE: ./components/Home/MainHome.jsx







var MainHome = function MainHome(_ref) {
  var _store$homePage, _store$homePage2, _store$homePage3;

  var store = _ref.store,
      theme = _ref.theme,
      hideHeroMedia = _ref.hideHeroMedia;
  var router = (0,next_router.useRouter)();
  var homeActive = !!(store !== null && store !== void 0 && store.homePageEnabled) && !hideHeroMedia;

  var updateHomeActive = function updateHomeActive() {
    router.push("/shop");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
    className: "w-screen max-w-[var(--max-width)] transition-[max-height] duration-200 flex-auto",
    children: [homeActive ? /*#__PURE__*/(0,jsx_runtime.jsx)(Home_FeaturedHome, {
      theme: theme,
      store: store,
      updateHomeActive: updateHomeActive,
      heroMedia: store === null || store === void 0 ? void 0 : (_store$homePage = store.homePage) === null || _store$homePage === void 0 ? void 0 : _store$homePage.heroMedia.url,
      heroMediaImages: store === null || store === void 0 ? void 0 : (_store$homePage2 = store.homePage) === null || _store$homePage2 === void 0 ? void 0 : _store$homePage2.heroMediaImages,
      heroMediaType: store === null || store === void 0 ? void 0 : (_store$homePage3 = store.homePage) === null || _store$homePage3 === void 0 ? void 0 : _store$homePage3.heroMediaType,
      heroTitle: store.homePage.heroTitle ? store.homePage.heroTitle : store.storeName
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollProvider, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Home_CollectionHome, {
        store: store,
        theme: theme
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/***/ }),

/***/ 7486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(214);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);





var reload = function reload() {
  window.location.reload();
};

var Error500Page = function Error500Page() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
      src: "/500.png",
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().title404),
      alt: "500 image"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundMessage),
      children: "We are over capacity! Please wait a moment and try again."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      onClick: reload,
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundHeadHome),
      children: "Refresh"
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Error500Page);

/***/ }),

/***/ 3046:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselImageContainer":"featured-home_carouselImageContainer__ksnob","carouselImage":"featured-home_carouselImage__3aVoz","carouselVideoContainer":"featured-home_carouselVideoContainer__Pz41Z"};

/***/ }),

/***/ 3405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"infobanner":"static-infobanner_infobanner__FrEI3"};

/***/ })

}]);